

<template>
  <div>
    <h2>Administrative form</h2>
    <user-form v-if="questions != null && values != null && errorMessages != null" ref="userForm"
      :questions="questions"
      :values="values"
      :error-messages="errorMessages"
      >
    </user-form>
    <div v-else>
      Update the webpage ...
    </div>


    <div v-if="userFormHasError" style="color: red">
      Complete the form before paying
    </div>

    <div class="centered-child" style="margin-top: 48px">
      <md-button class="md-raised md-primary large-button" @click="onClickValidate()">Confirm</md-button>
    </div>

  </div>

</template>

<script>
import UserForm from '../components/UserForm'
import ServiceAccess from '../service/ServiceAccess'

export default {
  components: {
    'user-form': UserForm
  },

  data: function () {
    return {
      email: null,
      questions: null,
      errorMessages: null,
      values: null,
      userFormHasError: false
    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      // ServiceAccess.instance.loadScreens(),
      ServiceAccess.instance.loadErrorMessages(),
      ServiceAccess.instance.loadQuestions()
    ]
    Promise.all(promises).then(responses => {
      let [values, errorMessages, questions] = responses
      this.values = values
      // this.screens = screens
      this.errorMessages = errorMessages
      this.questions = questions
      this.$forceUpdate()
    })
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      this.$router.back()
    },


    valueUpdated: function (qid, v) {
      this.values[qid] = v
    },

    onClickValidate: function () {
      this.userFormHasError = this.$refs.userForm.hasError()
      if (!this.userFormHasError) {
        ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)

        if (this.$route.params.cart === 'VISA') {
          this.$router.push('/f/' + this.$route.params.sessionId + '/payment/' + this.$route.params.cart)
        } else {
          this.$router.push('/f/' + this.$route.params.sessionId + '/preview/' + this.$route.params.cart)
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// CheckoutForm.vue?01763c31